import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const ComplianceCategory = { id: 13, name: 'Compliance' };
const WebSearch = { id: 18, name: 'Web Search' };
export const inputGuardrailsPrompt = defineFeature({
    type: FeatureType.String,
    propName: 'input_guardrails_prompt',
    uiName: 'inputGuardrailsPrompt',
    displayName: 'Input Guardrails Prompt',
    description: 'Prompt identifier used to validate incoming user input before orchestration runs.',
    category: ComplianceCategory,
    areas: ['agent'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    editor: 'prompt-select',
    surfacedIn: ['agent'],
});
export const webSearchCompliancePrompt = defineFeature({
    type: FeatureType.String,
    propName: 'web_search_compliance_prompt',
    uiName: 'webSearchCompliancePrompt',
    displayName: 'Web Search Compliance Prompt',
    description: 'Optional extra prompt identifier used to screen the user query before any web-search call, in addition to the standard screen that always runs. It runs after the standard screen on the query that screen produced, and returns a structured allow/rewrite/block decision biased toward rewriting sensitive content. When blank, only the standard screen runs.',
    category: WebSearch,
    areas: ['agent'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    editor: 'prompt-select',
    surfacedIn: ['agent'],
});
export const complianceFeatures = [inputGuardrailsPrompt, webSearchCompliancePrompt];
